import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';
import SoftwareSectionTextItem from 'dpl/join_as_breeder/components/SoftwareSectionTextItemV3';

import breederBadgeImg from 'dpl/assets/breeder_badge.svg';

export default function SoftwareSectionV3({
  softwareItems,
  setRef,
  shownRotatingContentIdx,
  isRotatingContentShown,
  isRotatingContentPaused,
  rotatingContentInterval,
  resumeRotatingContent,
  pauseRotatingContent
}) {
  const shownItem = softwareItems[shownRotatingContentIdx];

  return (
    <div className="BreederJoinSoftwareSection" ref={setRef}>
      <div className="row no-gutters">
        <div className="col-md-6">
          <div
            className={classnames(
              'BreederJoinSoftwareSection__image absolute absolute--fill ph18-lg ph4 tc',
              {
                'BreederJoinSoftwareSection__image--shown':
                  isRotatingContentShown,
                'o-0': !isRotatingContentShown
              }
            )}
          >
            {shownItem?.photographs?.[0] && (
              <div className="d-none d-md-inline-block relative">
                <SmartImage
                  Tag="div"
                  className="bg-center contain"
                  height="576px"
                  width="300px"
                  lazy={shownRotatingContentIdx === 0}
                  src={shownItem.photographs[0].url}
                />
                <div className="BreederJoinSoftwareSection__badge absolute left-0 bottom-0 z-1">
                  <SmartImage
                    lazy
                    alt="Good Breeder Badge"
                    forceOriginalSrc
                    src={breederBadgeImg}
                    width="148px"
                    height="148px"
                    className="mw-100"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <ul className="BreederJoinSoftwareSection__textItemList col-md-6">
          {softwareItems.map((item, idx) => (
            <li key={idx}>
              <button
                type="button"
                className="mb12-lg mb4"
                onMouseEnter={() => pauseRotatingContent(idx)}
                onMouseLeave={resumeRotatingContent}
              >
                <SoftwareSectionTextItem
                  title={item.title}
                  paragraph={item.long_description}
                  isSelected={idx === shownRotatingContentIdx}
                  borderTransitionDuration={
                    !isRotatingContentPaused && rotatingContentInterval
                  }
                />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

SoftwareSectionV3.propTypes = {
  softwareItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      long_description: PropTypes.string.isRequired,
      photographs: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  setRef: PropTypes.object.isRequired,
  shownRotatingContentIdx: PropTypes.number,
  isRotatingContentShown: PropTypes.bool.isRequired,
  isRotatingContentPaused: PropTypes.bool.isRequired,
  rotatingContentInterval: PropTypes.number.isRequired,
  resumeRotatingContent: PropTypes.func.isRequired,
  pauseRotatingContent: PropTypes.func.isRequired
};

SoftwareSectionV3.defaultProps = {
  shownRotatingContentIdx: null
};
